'use client';

import { EmailField } from '@/shared/ui/forms/email-field';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ArrowRightIcon } from '@phosphor-icons/react/dist/ssr';
import { Button, Separator } from '@/shared/ui/core';
import {
    AuthCardContent, AuthCardDescription, AuthCardFooter, AuthCardHeader, AuthCardLogo, AuthCardTitle,
} from '@/shared/ui/layout/auth-card';
import { RegistrationCard } from '@/shared/ui/layout/registration-card';
import { HaveAnAccount } from '@/shared/ui/kit/have-an-account';
import { emailSchema, type EmailFormData } from '@/shared/lib/validation/registration-wizard/email';
import { useWizard } from '../../model/wizard-context';
import styles from './step-email.module.scss';


export const StepEmail = () => {
    const { state, dispatch } = useWizard();

    const form = useForm<EmailFormData>({
        resolver      : zodResolver(emailSchema),
        mode          : 'onBlur',
        reValidateMode: 'onChange',
        defaultValues : state.data.email ?? { email: '' },
    });

    const onSubmit = form.handleSubmit((data) => {
        dispatch({ type: 'commit', key: 'email', value: data });
        dispatch({ type: 'next' });
    });

    return (
        <RegistrationCard
            data-template="registration-steps-card"
            compact
        >
            <FormProvider { ...form }>
                <div data-template="step-email">
                    <AuthCardLogo data-template="email-form-logo"/>

                    <AuthCardHeader data-template="email-form-header">
                        <AuthCardTitle data-template="email-form-title">
                            Create an account
                        </AuthCardTitle>
                        <AuthCardDescription data-template="email-form-description">
                            Enter your email and we will guide you through the registration steps.
                        </AuthCardDescription>
                    </AuthCardHeader>

                    <AuthCardContent data-template="step-email-content">
                        <EmailField/>

                        <Button
                            fullWidth
                            onClick={ onSubmit }
                            leftIcon={ <ArrowRightIcon/> }
                            className={ styles.button }
                        >
                            Continue
                        </Button>
                    </AuthCardContent>

                    <AuthCardFooter data-template="step-email-footer">
                        <Separator/>

                        <HaveAnAccount className={ styles.footer_description }/>
                    </AuthCardFooter>
                </div>
            </FormProvider>
        </RegistrationCard>
    );
};
